export default () => ({
	loading: false,
	activity: null,
	activities: [],
	filterWord: '',
});
